import { SettingsController, TransactionsController } from '../../controllers';
import { theYear } from '../../utils/utils';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import constant from '../../utils/constant';
import { useStores } from '../../stores';
import { AppHome } from '../../pages';
import { observer } from 'mobx-react';
import { object, string } from 'yup';
import { getDate } from '../../utils/utils';
import { filterPeriods } from '../../utils/utils';
import moment from 'moment';

const AppHomeContainer = () => {
	const [allBusinesses, setAllBusinesses] = useState(false);
	const [reportModal, setReportModal] = useState(false);
	const [pinModal, setPinModal] = useState(false);
	const [withdrawalAccountModal, setWithdrawalAccountModal] = useState(false);

	const { userStore, businessStore, transactionStore } = useStores();

	const isActivated = userStore.isActivated;
	const hasPin = userStore.user.hasPin;
	const isOnboarded = userStore.isOnBoardingDone !== 'false';
	const hasWithdrawal = businessStore.business.withdrawalBankAccount;
	// const hasAddedCard = businessStore.business.card;
	const hasVerifiedNumber = businessStore.business.validateMobile !== false;

	let [a, b, c, d] = [0, 0, 0, 0];

	isActivated ? (a = 25) : (a = 0);
	// isOnboarded ? (b = 25) : (b = 0);
	hasVerifiedNumber ? (b = 25) : (b = 0);
	// hasAddedCard ? (b = 25) : (b = 0);
	hasPin ? (c = 25) : (c = 0);
	hasWithdrawal ? (d = 25) : (d = 0);

	let toDoListTotal = a + b + c + d;

	const navigate = useNavigate();

	const goToOnboarding = () => {
		!isOnboarded && navigate(constant.Routes.OnboardingStageOne);
	};

	const goToSettings = () => {
		navigate(constant.Routes.Settings);
	};

	useEffect(() => {
		const setTransactions = async () =>
			await Promise.all([
				SettingsController.dashboardData(),
				TransactionsController.transactions(),
				// InvoiceController.getAnalysis(),
			]);
		setTransactions();
	}, []);

	// const [filterPeriod, setFilterPeriod] = useState(`${monthName} ${theYear}`);
	const [filterPeriod, setFilterPeriod] = useState(`${theYear}`);
	const [loading, setLoading] = useState(false);

	const validationSchema = () => {
		return object({
			startDate: string().required('Start Date is required'),
			endDate: string().required('End Date is required'),
		});
	};


	const onSubmit = async payload => {
		let query;

		if (payload && Object.keys(payload).length > 0) {
			query = `startDate=${payload.startDate}&endDate=${payload.endDate}&dateField=createdAt`;
			if (payload.period === 'custom') {
				setFilterPeriod(
					`${moment(payload?.startDate).format('DD-MM-YYYY')} - ${moment(payload.endDate).format('DD-MM-YYYY')}`
				);
			} else {
				setFilterPeriod(`${payload?.periodText}`);
			}
			// setFilterPeriod(
			// 	`${payload?.startDate.toDateString()} - ${payload.endDate.toDateString()}`
			// );
		}
		setLoading(true);
		await Promise.all([
			TransactionsController.transactionSummary(query),
			TransactionsController.transactions(query),
		]);
		setLoading(false);
	};
	const refresh = async () => {
		setLoading(true);
		await Promise.all([
			TransactionsController.transactionSummary(),
			TransactionsController.transactions(),
		]);
		setLoading(false);
	};

	const logout = () => {
		userStore.setLoggedIn(false);
	};

	const resetFilter = async () => {
		await onSubmit();
		setFilterPeriod(`${theYear}`);
	};

	const viewReport = () => {
		setReportModal(true);
	};

	const goToSetPin = () => {
		setPinModal(true);
	};

	const goToWithdrawalAccount = () => {
		setWithdrawalAccountModal(true);
	};

	const closeModal = () => {
		setReportModal(false);
		setPinModal(false);
		setWithdrawalAccountModal(false);
	};

	return (
		<div>
			<AppHome
				logout={logout}
				validationSchema={validationSchema}
				onSubmit={onSubmit}
				tradingName={
					businessStore.business?.tradingName || userStore.user?.firstname
				}
				transactionsSummary={transactionStore.transactionsSummary}
				loading={loading}
				filterPeriod={filterPeriod}
				resetFilter={resetFilter}
				refresh={refresh}
				toDoListTotal={toDoListTotal}
				isActivated={isActivated}
				hasPin={hasPin}
				isOnboarded={isOnboarded}
				hasWithdrawal={hasWithdrawal}
				goToOnboarding={goToOnboarding}
				goToSettings={goToSettings}
				closeModal={closeModal}
				viewReport={viewReport}
				reportModal={reportModal}
				// hasAddedCard={hasAddedCard}
				goToSetPin={goToSetPin}
				goToWithdrawalAccount={goToWithdrawalAccount}
				pinModal={pinModal}
				withdrawalAccountModal={withdrawalAccountModal}
				hasVerifiedNumber={hasVerifiedNumber}
				filterPeriods={filterPeriods}
				getDate={getDate}
			/>
		</div>
	);
};

export default observer(AppHomeContainer);
